import { LOGIN, LOGOUT, CLEAR_ERRORS, GET_TOKEN, RESET_PASSWORD, FIRST_TIME_LOGIN, SET_DEFAULT_REPORT, SET_PAGE_CAPTURE_LIMIT, SET_PAGE, SET_PAGE_VIEW } from '../types'
import { trackPromise } from 'react-promise-tracker'
import moment from 'moment'

import { defaultFilter } from '../../utils/variables'
import { parseResponse } from '@jweb-development/response-parser'
import log from 'loglevel'

const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

// Logs in the user to retrieve a JSON token from the API
export const login = (userName, password, accountID, fireLogin = () => { }) => {
  return async (dispatch = () => { }) => {
    try {
      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userName: userName,
          password: password,
          accountID: accountID
        })
      }
      const response = await trackPromise(window.fetch(`${api}/auth/login`, options))
      const parseOptions = {
        dispatch,
        shouldDispatch: true,
        dispatchType: LOGOUT,
        payload: { message: 'Invalid credentials. Please try again.', error: true }
      }
      const parsedResponse = parseResponse(response, parseOptions)

      if (parsedResponse && !parsedResponse.error) {
        const { data = {} } = await response.json()
        // log.debug(data)
        const {
          defaultUserReport: defaultReport = '', defaultUserPage: defaultPage = '', defaultUserView: defaultView = '',
          defaultUserCaptureCount: defaultCaptureCount = '',
          accountID: accountId = null, roleID: assignedRole = null, assignedUnits = [], firstName = null, firstTimeLogin = 0,
          lastName = null, passwordResetRequired = false, permissions = [], supervisorID = null, token = null, tokenExp = null,
          username = null, unitSupervisorMap = [], unitTree = [], userhash = null
        } = data

        dispatch({
          type: SET_DEFAULT_REPORT,
          payload: { ...defaultFilter, captureAreas: defaultReport === 'A' ? [] : [defaultReport] }
        })
        // dispatch({ type: SET_PAGE, payload: defaultPage })
        dispatch({ type: SET_PAGE_VIEW, payload: defaultView })
        dispatch({ type: SET_PAGE_CAPTURE_LIMIT, payload: defaultCaptureCount })

        const loginInfo = {
          accountId,
          assignedRole,
          assignedUnits,
          defaultPage,
          defaultView,
          defaultReport,
          firstName,
          firstTimeLogin: Boolean(firstTimeLogin),
          lastName,
          passwordResetRequired,
          permissions,
          supervisorID,
          token,
          tokenExp,
          username,
          unitSupervisorMap,
          unitTree,
          userhash
        }

        dispatch({ type: LOGIN, payload: loginInfo })
      } else {
        return fireLogin()
      }
    } catch (err) {
      console.error(err)
      fireLogin()
    }
  }
}

export const getAccountFromDomain = async (domain) => {
  try {
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ domain })
    }

    log.debug(api)
    log.debug(process.env.react)

    const response = await trackPromise(window.fetch(`${api}/auth/domains`, options))
    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      const { data } = await response.json()
      return data
    } else {
      console.error('error fetching account details')
      return false
    }
  } catch (err) {
    console.error(err)
    return false
  }
}

export const loginSSO = () => {
  return async function (dispatch) {
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const response = await trackPromise(window.fetch('https://collier-test.ngrok.io/sso/saml', options))
    const data = await response.json()
    log.debug(data)
  }
}

export const loginGoogle = () => {
  return async function (dispatch) {
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const response = await trackPromise(window.fetch(`${api}/sso/google`, options))
    const data = await response.json()
    log.debug(data)
  }
}

export const logout = () => {
  return async function (dispatch, getState) {
    try {
      const { token, supervisorID, accountId } = getState().auth
      const body = {
        accountID: accountId,
        supervisorID: supervisorID
      }
      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      }

      const response = await trackPromise(window.fetch(`${api}/auth/logout`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const res = await response.json()

        if (res && res.data && res.data.requestUrl && res.data.requestUrl.length > 0) {
          // Redirect to the SSO url
          const { requestUrl } = res.data
          dispatch({ type: LOGOUT, payload: { message: 'You have successfully logged out.' } })
          window.location.href = requestUrl
        }
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch({ type: LOGOUT, payload: { message: 'You have successfully logged out.' } })
    }
  }
}

export const inactivityLogout = () => {
  // TODO: [LG-106] invalidate the token server side
  return function (dispatch) {
    dispatch({
      type: LOGOUT,
      payload: {
        message: 'You have been logged out due to inactivity.',
        error: true
      }
    })
    // dispatch({ type: RESET_INITIAL_STATE })
  }
}

const invalidCredentialsLogout = (dispatchAction) => {
  dispatchAction({
    type: LOGOUT,
    payload: {
      message: 'Invalid credentials. Please try again.',
      error: true
    }
  })
}

// Gets JSON token to interact with the Web API
export const getToken = async (state, dispatchAction) => {
  const { token, tokenExp, accountId, supervisorID } = state
  const diff = tokenExp ? moment().diff(tokenExp) : 0
  if (typeof token !== 'undefined' && diff < -600000) {
    return token
  } else {
    const body = {
      accountID: accountId,
      supervisorID: supervisorID
    }
    // log.debug(body)

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }
    const response = await trackPromise(window.fetch(`${api}/auth/token/refresh`, options))
    if (!response.status || response.status !== 200) {
      return invalidCredentialsLogout(dispatchAction)
    } else {
      const { data } = await response.json()
      log.info('fetched token refresh!')
      // log.debug(data)
      dispatchAction({
        type: GET_TOKEN,
        payload: data
      })
      return data.token
    }
  }
}

// Sends current token in for a fresh one
export const refreshToken = () => {
  return async function (dispatch, getState) {
    const { token, supervisorID, accountId } = getState().auth
    const body = {
      accountID: accountId,
      supervisorID: supervisorID
    }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }
    const response = await trackPromise(window.fetch(`${api}/auth/token/refresh`, options))
    if (!response.status || response.status !== 200) {
      log.info('logging out')
      return invalidCredentialsLogout(dispatch)
      // return false
    } else {
      const { data } = await response.json()
      dispatch({
        type: GET_TOKEN,
        payload: data
      })
    }
  }
}

// Sends current token in for a fresh one
export const refreshTokenSSO = (token, supervisorID, accountID, userName) => {
  return async function (dispatch) {
    try {
      const body = { accountID, supervisorID, userName }

      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      }
      const response = await trackPromise(window.fetch(`${api}/auth/token/refresh/sso`, options))
      if (!response.status || response.status !== 200) {
        log.info('logging out')
        return invalidCredentialsLogout(dispatch)
        // return false
      } else {
        const data = await response.json()
        // log.debug(data)
        await dispatch({
          type: SET_DEFAULT_REPORT,
          payload: { ...defaultFilter, captureAreas: data.defaultUserReport === 'A' ? [] : [data.defaultUserReport] }
        })
        await dispatch({
          type: SET_PAGE,
          payload: data.defaultUserPage
        })
        await dispatch({
          type: SET_PAGE_VIEW,
          payload: data.defaultUserView
        })
        await dispatch({
          type: SET_PAGE_CAPTURE_LIMIT,
          payload: data.defaultUserCaptureCount
        })
        data.accountId = accountID
        dispatch({
          type: LOGIN,
          payload: { ...data, assignedRole: data.roleID, isSSO: true }
        })
      }
    } catch (err) {
      console.error(err)
    }
  }
}

// TODO integrate this with the supervisor/:id endpoint
export const setUser = (token, accountID, supervisorID, username) => {
  return function (dispatch) {
    const payload = {
      token: token,
      accountID: accountID,
      supervisorID: supervisorID,
      username: username
    }
    dispatch({
      type: LOGIN,
      payload: payload
    })
  }
}

export const clearErrors = () => {
  // TODO: [LG-106] invalidate the token server side
  return function (dispatch) {
    dispatch({
      type: CLEAR_ERRORS
    })
  }
}

export const resetPasswordRequired = () => {
  return function (dispatch) {
    dispatch({
      type: RESET_PASSWORD
    })
  }
}

export const resetFirstTimeLogin = () => {
  return async function (dispatch, getState) {
    const { token, supervisorID, accountId } = getState().auth
    const body = {
      accountID: accountId,
      supervisorID: supervisorID
    }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }
    const response = await trackPromise(window.fetch(`${api}/auth/login/first`, options))
    if (!response.status || response.status === 401) {
      log.info('logging out')
      return invalidCredentialsLogout(dispatch)
      // return false
    } else {
      dispatch({
        type: FIRST_TIME_LOGIN
      })
    }
  }
}

export const resetPassword = (emailAddress, accountID, fireSuccess, fireFailure) => {
  return async function (dispatch) {
    const body = {
      accountID,
      emailAddress
    }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/supervisors/passwordreset`, options))
    if (response && (response.status === 200 || response.status === 400)) {
      fireSuccess()
    } else {
      fireFailure()
    }
  }
}
